import Head from 'next/head';
import { useRouter } from 'next/router';
import config from 'lib/config';
import { getLocalizedUrlsFromPath } from 'lib/Utilities';
import ogDefaultImage from 'public/static/images/og_default_placeholder.png';
import msIcon from 'public/static/images/ms-icon-144x144.png';

export interface SeoSrpHeadProps {
  description?: string;
  title?: string;
}

export default function SeoSrpHead({ description, title }: SeoSrpHeadProps): JSX.Element {
  const { asPath } = useRouter();
  const urls = getLocalizedUrlsFromPath(asPath, config.host);

  return (
    <Head>
      <link href={`https://${urls.en}`} rel="canonical" />
      <meta content="#ffffff" name="msapplication-TileColor" />
      <meta content="#ffffff" name="theme-color" />
      <meta content="1200" property="og:image:width" />
      <meta content="630" property="og:image:height" />
      <meta content={title} name="twitter:title" />
      <meta content={description} name="twitter:description" />
      <meta content="summary_large_image" name="twitter:card" />
      <meta content="@autolistcom" name="twitter:site" />

      <meta content={ogDefaultImage} name="twitter:image" />
      <meta content={msIcon} name="msapplication-TileImage" />
      <meta content={ogDefaultImage} property="og:image" />
    </Head>
  );
}
